import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CourseContext } from "../../App";

export default function Footer() {

    const { courses } = useContext(CourseContext);

    return (
        <>
            <footer>
                <Container>
                    <Row>
                        <Col sm={12} xl={4} className="mt-4">
                            <Row>
                                <Col sm={12} className="mt-4">
                                    <h2 className="main-title">
                                        <Link to="/">
                                            Студия
                                            <br />
                                            Развития
                                            <br />
                                            Детской
                                            <br />
                                            Речи
                                        </Link>
                                    </h2>
                                    <div className="my-3 sociallinks d-flex gap-2">
                                        <a href="https://wa.me/+79951161843" target="_blank">
                                            <img src="/icons/whatsapp.svg" />
                                        </a>
                                        <a href="https://t.me/govoroksupport" target="_blank">
                                            <img src="/icons/telegram.svg" />
                                        </a>
                                    </div>
                                    <p className="text-dark d-none d-md-block">
                                        Индивидуальный предприниматель
                                        <br />
                                        Смагина Наталья Игоревна
                                        <br />
                                        ИНН 503007516731
                                        <br />
                                        ОГРНИП 324774600650154
                                        <br />
                                        Адрес: г. Москва, ул. Маршала Савицкого, д. 16, корп. 1, кв. 126.
                                        <br />
                                        E-mail: logoped-smagina@yandex.ru
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={12} xl={8} className="mt-4">
                            <Row>
                                <Col sm={12} md={6} lg={4} className="mt-0 mt-sm-4">
                                    <div className="d-lg-flex flex-column align-items-center">
                                        <div>
                                            <h3 className="secondary-title text-uppercase">
                                                Содержание
                                            </h3>
                                            <ul>
                                                <li>
                                                    <Link
                                                        to="/"
                                                        onClick={() => {
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                        }}
                                                    >
                                                        Главная
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="/?id=courses"
                                                    >
                                                        Курсы
                                                    </Link>
                                                </li>
                                                <li><Link
                                                    to="/?id=about"
                                                >
                                                    Обо мне
                                                </Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={4} className="mt-0 mt-sm-4">
                                    <div className="d-lg-flex flex-column align-items-center">
                                        <div>
                                            <h3 className="secondary-title text-uppercase">
                                                КУРСЫ
                                            </h3>
                                            <ul style={{ textTransform: "capitalize" }}>
                                                {
                                                    courses && courses.length ?
                                                        courses.map((item, index) => {
                                                            return <li key={index}><Link to={`/course-view/${item.id}`}>{item.title}</Link></li>
                                                        })
                                                        : null
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} md={6} lg={4} className="mt-0 mt-sm-4" >
                                    <div className="d-lg-flex flex-column align-items-center">
                                        <div>
                                            <h3 className="secondary-title text-uppercase">
                                                Документы
                                            </h3>
                                            <ul>
                                                <li><Link to="/privacy-policy"> Политика Конфиденциальности</Link></li>
                                                <li><Link to="/offer">Оферта</Link></li>
                                                <li><Link to="/newsletter-consent">Согласие на получение информационной и рекламной рассылки</Link></li>
                                                <li><Link to="/data-processing-consent">Согласие на обработку персональных данных</Link></li>
                                                <li><Link to="/data-processing-consent">Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col className=" d-block d-md-none mt-5">
                                    <p className="text-dark">
                                        Индивидуальный предприниматель
                                        <br />
                                        Смагина Наталья Игоревна
                                        <br />
                                        ИНН 503007516731
                                        <br />
                                        ОГРНИП 324774600650154
                                        <br />
                                        Адрес: г. Москва, ул. Маршала Савицкого, д. 16, корп. 1, кв. 126.
                                        <br />
                                        E-mail: logoped-smagina@yandex.ru
                                    </p>

                                </Col>
                            </Row>
                        </Col>



                    </Row>
                </Container>
            </footer>
        </>
    )
}